import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";

const Navbar = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({ name: "", role: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const user = JSON.parse(localStorage.getItem("user"));

    if (!isLoggedIn || !user) {
      localLogout();
      return;
    }

    setUserInfo({
      name: user.name || "User",
      role: user.role || "-",
    });
  }, []);

  const clearStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("user");
    localStorage.removeItem("accessMatrix");
    localStorage.removeItem("lastPath");
    localStorage.removeItem("isLoggedIn");
  };

  const localLogout = () => {
    clearStorage();
    setIsLoggedIn(false);
    navigate("/login");
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Apakah Anda yakin ingin keluar?");
    if (!confirmLogout) return;

    setLoading(true);
    setTimeout(() => {
      clearStorage();
      setIsLoggedIn(false);
      navigate("/login");
      setLoading(false);
    }, 300); // simulasi delay logout
  };

  return (
    <header className="fixed top-0 left-0 z-50 flex items-center justify-between w-full h-20 px-6 py-3 bg-white border-b border-green-100 shadow-sm print:hidden">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center text-xl font-semibold text-green-700 bg-green-100 rounded-full shadow-sm w-11 h-11">
          {userInfo.name?.charAt(0)?.toUpperCase()}
        </div>
        <div>
          <p className="text-base font-semibold text-green-800">
            {userInfo.name}
          </p>
          <p className="text-sm text-green-500">{userInfo.role}</p>
        </div>
      </div>

      <h1 className="hidden font-sans text-2xl font-bold tracking-wide text-green-700 md:block">
        Sistem Koperasi
      </h1>

      <button
        onClick={handleLogout}
        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-red-600 transition rounded-md shadow-sm bg-red-50 hover:bg-red-100"
        title="Keluar"
        disabled={loading}
      >
        {loading ? (
          "Logging out..."
        ) : (
          <>
            <FaSignOutAlt size={16} />
            <span className="hidden sm:inline">Logout</span>
          </>
        )}
      </button>
    </header>
  );
};

export default Navbar;
